import type { IWebCOOSMapAsset } from "@/services/assets/types"
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}


export const ucFirst = (str?: string | null) => {
  if (!str) return ''
  if (str.toLowerCase() === 'na') {
    return str.toUpperCase()
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const primaryHex = '#33899e'
export const primaryLighterHex = '#E0F5F3'
export const redHex = '#FF0000'


export const legendItems = [
  {
    id: 'active',
    label: 'Up',
    color: 'bg-primary',
    hexColor: primaryHex,
    hexStroke: '#FFF',
    filter: (asset: IWebCOOSMapAsset) => asset.asset_disposition_slug?.toLowerCase() === 'up',
    sortOrder: 10
  },
  {
    id: 'archived',
    label: 'Archived',
    color: 'bg-primary-lighter',
    border: 'border-primary',
    hexColor: primaryLighterHex,
    hexStroke: primaryHex,
    filter: (asset: IWebCOOSMapAsset) => asset.asset_disposition_slug?.toLowerCase() === 'archived',
    sortOrder: 9
  },
  /* {
      id: 'live',
      label: 'Live',
      color: 'bg-green-500',
      hexColor: '#00FF00',
      filter: (asset: IWebCOOSMapAsset) => asset.asset_disposition_label === 'up'
  },
  {
      id: 'pending',
      label: 'Pending',
      color: 'bg-gray-500',
      hexColor: '#808080',
      filter: (asset: IWebCOOSMapAsset) => asset.asset_disposition_label === 'pending'
  }, */
  {
    id: 'down',
    label: 'Down',
    color: 'bg-red-500',
    hexColor: redHex,
    hexStroke: '#FFF',
    border: 'border-white',
    filter: (asset: IWebCOOSMapAsset) => asset.asset_disposition_label?.toLowerCase() === 'down',
    sortOrder: 8
  }
]

export const getLegendItemForAsset = (asset: IWebCOOSMapAsset) => {
  return legendItems.find(item => item.filter(asset))
}